module.exports = __webpack_public_path__ + "img/cards_square_bottom.fe6488bf.svg";